module.exports = __webpack_public_path__ + "click-on-call.png?98f1dc37084627e233a159b61b70e7b8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/click-on-call.png
// module id = 7
// module chunks = 0